<template>
  <div
    class="form-tip-box"
    :class="{
      'form-tip-box--section': spacing === 'section',
      'form-tip-box--compact': spacing === 'compact',
    }"
    role="note"
    :aria-label="ariaLabel"
  >
    <div class="form-tip-box__head">
      <i class="ri-lightbulb-flash-line" aria-hidden="true"></i>
      <span>{{ title }}</span>
    </div>
    <div class="form-tip-box__body">
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({
  /** 標題列文字，預設「提示」 */
  title: { type: String, default: '提示' },
  /** section：區塊開頭整段說明（下邊距較大）；compact：欄位下方說明；預設：一般上方留白 */
  spacing: {
    type: String,
    default: 'default',
    validator: (v) => ['default', 'section', 'compact'].includes(v),
  },
  ariaLabel: { type: String, default: '提示說明' },
});
</script>

<style scoped>
.form-tip-box {
  margin-top: 10px;
  border: 1px solid #bae6fd;
  border-radius: 10px;
  border-left: 4px solid #0ea5e9;
  background: #fff;
  box-shadow: 0 1px 3px rgba(14, 165, 233, 0.08);
  overflow: hidden;
}

.form-tip-box--section {
  margin-top: 0;
  margin-bottom: 16px;
}

.form-tip-box--compact {
  margin-top: 10px;
}

.form-tip-box__head {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #0369a1;
  background: linear-gradient(180deg, #e0f2fe 0%, #f0f9ff 100%);
  border-bottom: 1px solid #bae6fd;
}

.form-tip-box__head i {
  font-size: 15px;
  color: #0284c7;
}

.form-tip-box__body {
  padding: 12px 14px;
  background: #fafefe;
}

.form-tip-box__body :deep(.form-hint:first-child),
.form-tip-box__body :deep(.field-hint:first-child) {
  margin-top: 0;
}

.form-tip-box__body :deep(.form-hint:last-child),
.form-tip-box__body :deep(.field-hint:last-child) {
  margin-bottom: 0;
}

.form-tip-box__body :deep(.form-hint),
.form-tip-box__body :deep(.field-hint) {
  font-size: 12px;
  color: #6b7280;
  margin: 6px 0 0;
  line-height: 1.55;
}

.form-tip-box__body :deep(.form-hint strong),
.form-tip-box__body :deep(.field-hint strong) {
  color: #4b5563;
}

.form-tip-box__body :deep(.form-hint code),
.form-tip-box__body :deep(.field-hint code) {
  font-size: 11px;
  padding: 1px 4px;
  background: #f3f4f6;
  border-radius: 4px;
  color: #4b5563;
}

.form-tip-box__body :deep(.form-hint--example),
.form-tip-box__body :deep(.field-hint-example) {
  margin-top: 8px;
  padding: 8px 10px;
  background: #fff;
  border: 1px dashed #e5e7eb;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.5;
}

.form-tip-box__body :deep(.form-hint--preview),
.form-tip-box__body :deep(.field-hint-preview-path) {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #e5e7eb;
  line-height: 1.6;
}

.form-tip-box__body :deep(.seo-example-text) {
  color: #374151;
  font-style: normal;
}

.form-tip-box__body :deep(.form-hint-sub),
.form-tip-box__body :deep(.field-hint-sub) {
  display: block;
  margin-top: 6px;
  font-size: 11px;
  color: #9ca3af;
  line-height: 1.5;
}

.form-tip-box__body :deep(.slug-preview-code),
.form-tip-box__body :deep(.seo-path-code) {
  display: inline-block;
  margin: 0 4px;
  padding: 2px 8px;
  font-size: 13px;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  color: #1f2937;
}

.form-tip-box__body :deep(.seo-help-intro) {
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: #4b5563;
}

.form-tip-box__body :deep(.seo-help-intro strong) {
  color: #374151;
}
</style>
